
import { useQuery } from "@tanstack/react-query";
import { feedService } from "@/services/feedService";
import { useAuth } from "@/context/AuthContext";
import PostCard from "@/components/profile/PostCard";
import CommentActivityCard from "@/components/profile/CommentActivityCard";
import PodcastCommentActivityCard from "@/components/profile/PodcastCommentActivityCard";
import { Skeleton } from "@/components/ui/skeleton";
import { MessageSquare } from "lucide-react";
import T from "@/i18n/T";

const FollowingFeed = () => {
  const { user } = useAuth();
  const { data: activities, isLoading } = useQuery({
    queryKey: ['following-feed', user?.id],
    queryFn: () => feedService.getFollowingFeed(user!.id),
    enabled: !!user,
  });

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }

  if (!activities || activities.length === 0) {
    return (
      <div className="text-center py-12">
        <MessageSquare className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold"><T k="auto.nothing-to-see-here-yet-a18a" /></h3>
        <p className="text-muted-foreground"><T k="auto.when-you-follow-people-their-posts-will-4e18" /></p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activities.map((activity: any) => {
        if (activity.type === 'post') {
          return <PostCard key={`post-${activity.id}`} post={activity} />;
        } else if (activity.type === 'podcast_comment') {
          return <PodcastCommentActivityCard key={`podcast-comment-${activity.id}`} comment={activity} />;
        } else {
          return <CommentActivityCard key={`comment-${activity.id}`} comment={activity} />;
        }
      })}
    </div>
  );
};

export default FollowingFeed;
